import React from 'react';

interface IIcon {
  width?: number;
}

const Icon: React.FC<IIcon> = () => null;

export default Icon;
